export function splitByComma (value) {
  if (value == null || value == '') {
    return null
  }

  if (value.includes(',')) {
    // 如果有逗号，就按照逗号分割成数组
    return value.split(',')
  } else {
    // 如果没有逗号，就返回原值
    return [value]
  }
}
